export const initialData = {
  sections: [
    // ===== SECTION 1: Company Info =====
    {
      id: 'section-1',
      title: 'Company Info',
      questions: [
        {
          id: 'q-1-1',
          type: 'text',
          label: 'Company Name?',
          name: 'company_name',
          placeholder: 'Enter company name',
          value: ''
        },
        {
          id: 'q-1-2',
          type: 'text',
          label: 'Company Partner?',
          name: 'company_partner',
          placeholder: 'Enter company partner',
          value: ''
        },
        {
          id: 'q-1-3',
          type: 'text',
          label: 'Company Abbreviation?',
          name: 'company_abbreviation',
          placeholder: 'Enter company abbreviation',
          value: ''
        }
      ]
    },
    // ===== SECTION 1A: Payroll Schedule =====
    {
      id: 'section-1a',
      title: 'Payroll Schedule',
      questions: [
        {
          id: 'q-1a-1',
          type: 'dropdown',
          label: 'What is your Payroll Schedule frequency?',
          name: 'payroll_frequency',
          options: ['Select', 'Weekly', 'Bi-Weekly', 'Monthly', 'Twice Per Month'],
          value: ''
        },
        {
          id: 'q-1a-2',
          type: 'text',
          label: 'Provide the Payroll Pay Period Date?',
          name: 'payroll_date',
          placeholder: '',
          value: ''
        },
        {
          id: 'q-1a-3',
          type: 'text',
          label: 'Provide the Payroll Pay Period End Date?',
          name: 'payroll_end_date',
          placeholder: '',
          value: ''
        }
      ]
    },
    // ===== SECTION 2: Employee Categories =====
    {
      id: 'section-2',
      title: 'Employee Categories',
      questions: [
        {
          id: 'q-2-1',
          type: 'dropdown',
          label: 'Do you have Part-Time or Variable Hour employees?',
          name: 'parttime_variable',
          options: ['Select', 'Yes', 'No'],
          value: ''
        },
        {
          id: 'q-2-2',
          type: 'dropdown',
          label: 'Do you have any categorizations for the purpose of benefits/accounting and reporting?',
          name: 'benefit_categorizations',
          options: ['Select', 'Yes', 'No'],
          value: ''
        }
      ]
    },
    // ===== SECTION 3: Company Setup =====
    {
      id: 'section-3',
      title: 'Company Setup',
      questions: [
        {
          id: 'q-3-1',
          type: 'dropdown',
          label: 'Transactions to Pend for administrator approval?',
          name: 'pend_approval',
          options: ['Select', 'Required', 'Not Required'],
          value: ''
        },
        {
          id: 'q-3-2',
          type: 'dropdown',
          label: 'Display rates in the system as?',
          name: 'display_rates',
          options: ['Select', 'Monthly', 'Per Pay Period'],
          value: ''
        },
        {
          id: 'q-3-3',
          type: 'dropdown',
          label: 'Show Costs?',
          name: 'show_costs',
          options: ['Select', 'Employee', 'Employer', 'Total'],
          value: ''
        },
        // ===== NEW HIRE EMAIL REMINDER - INDIVIDUAL FIELDS =====
        {
          id: 'q-3-4-1',
          type: 'dropdown',
          label: 'New Hire Email Reminder?',
          name: 'new_hire_email_option',
          options: ['Select an Option', 'Daily Send email X days before due date', 'Weekly Send email X days before due date', 'Every Two Weeks Send email X days before due date', 'Monthly Send email X days before due date'],
          value: ''
        },
        {
          id: 'q-3-4-2',
          type: 'number',
          label: 'Days',
          name: 'new_hire_email_days',
          placeholder: 'Enter Number of days',
          value: ''
        },
        {
          id: 'q-3-5',
          type: 'dropdown',
          label: 'What would be the cutoff date for payroll deductions?',
          name: 'payroll_deduction_cutoff',
          options: ['Select', 'Pay Check Date', 'Pay Cycle End Date', 'Other'],
          value: ''
        },
        {
          id: 'q-3-6',
          type: 'dropdown',
          label: 'Does the Qualifying Events enrollment require Transaction approval?',
          name: 'qe_requires_approval',
          options: ['Select', 'Yes', 'No'],
          value: ''
        },
        {
          id: 'q-3-7',
          type: 'dropdown',
          label: 'Does New Hire enrollment require Transaction approval?',
          name: 'newhire_requires_approval',
          options: ['Select', 'Yes', 'No'],
          value: ''
        }
      ]
    },
    // ===== SECTION 4: Carriers =====
    {
      id: 'section-4',
      title: 'Carriers',
      questions: [
        {
          id: 'q-4-1',
          type: 'subgrid',
          label: 'Initial Implementation',
          name: 'dd_impl',
          fields: [
            { id: 'q-4-1-1', type: 'text', label: 'Name', name: 'dd_impl_name', placeholder: 'Enter name', value: '' },
            { id: 'q-4-1-2', type: 'email', label: 'Email', name: 'dd_impl_email', placeholder: 'Enter email', value: '' },
            { id: 'q-4-1-3', type: 'text', label: 'Phone Number', name: 'dd_impl_phone', placeholder: 'Enter phone', value: '' }
          ]
        },
        {
          id: 'q-4-2',
          type: 'subgrid',
          label: 'Account Manager',
          name: 'dd_am',
          fields: [
            { id: 'q-4-2-1', type: 'text', label: 'Name', name: 'dd_am_name', placeholder: 'Enter name', value: '' },
            { id: 'q-4-2-2', type: 'email', label: 'Email', name: 'dd_am_email', placeholder: 'Enter email', value: '' },
            { id: 'q-4-2-3', type: 'text', label: 'Phone Number', name: 'dd_am_phone', placeholder: 'Enter phone', value: '' }
          ]
        },
        {
          id: 'q-4-3',
          type: 'subgrid',
          label: 'Initial Implementation',
          name: 'eq_impl',
          fields: [
            { id: 'q-4-3-1', type: 'text', label: 'Name', name: 'eq_impl_name', placeholder: 'Enter name', value: '' },
            { id: 'q-4-3-2', type: 'email', label: 'Email', name: 'eq_impl_email', placeholder: 'Enter email', value: '' },
            { id: 'q-4-3-3', type: 'text', label: 'Phone Number', name: 'eq_impl_phone', placeholder: 'Enter phone', value: '' }
          ]
        },
        {
          id: 'q-4-4',
          type: 'subgrid',
          label: 'Account Manager',
          name: 'eq_am',
          fields: [
            { id: 'q-4-4-1', type: 'text', label: 'Name', name: 'eq_am_name', placeholder: 'Enter name', value: '' },
            { id: 'q-4-4-2', type: 'email', label: 'Email', name: 'eq_am_email', placeholder: 'Enter email', value: '' },
            { id: 'q-4-4-3', type: 'text', label: 'Phone Number', name: 'eq_am_phone', placeholder: 'Enter phone', value: '' }
          ]
        },
        {
          id: 'q-4-5',
          type: 'subgrid',
          label: 'Initial Implementation',
          name: 'sfh_impl',
          fields: [
            { id: 'q-4-5-1', type: 'text', label: 'Name', name: 'sfh_impl_name', placeholder: 'Enter name', value: '' },
            { id: 'q-4-5-2', type: 'email', label: 'Email', name: 'sfh_impl_email', placeholder: 'Enter email', value: '' },
            { id: 'q-4-5-3', type: 'text', label: 'Phone Number', name: 'sfh_impl_phone', placeholder: 'Enter phone', value: '' }
          ]
        },
        {
          id: 'q-4-6',
          type: 'subgrid',
          label: 'Account Manager',
          name: 'sfh_am',
          fields: [
            { id: 'q-4-6-1', type: 'text', label: 'Name', name: 'sfh_am_name', placeholder: 'Enter name', value: '' },
            { id: 'q-4-6-2', type: 'email', label: 'Email', name: 'sfh_am_email', placeholder: 'Enter email', value: '' },
            { id: 'q-4-6-3', type: 'text', label: 'Phone Number', name: 'sfh_am_phone', placeholder: 'Enter phone', value: '' }
          ]
        }
      ]
    },
    // ===== SECTION 5: Medical =====
    {
      id: 'section-5',
      title: 'Medical',
      questions: [
        {
          id: 'q-5-1',
          type: 'text',
          label: 'Group Number?',
          name: 'medical_group_number',
          placeholder: 'Enter group number',
          value: ''
        },
        {
          id: 'q-5-1-1',
          type: 'checkbox',
          label: 'Payroll Deduction Tax?',
          name: 'medical_payroll_deduction_tax',
          options: ['Pre-Tax', 'Post-Tax'],
          value: []
        },
        {
          id: 'q-5-2',
          type: 'dropdown',
          label: 'Is this plan HSA compatible?',
          name: 'medical_hsa_compatible',
          options: ['Select', 'Yes', 'No'],
          value: ''
        },
        {
          id: 'q-5-3',
          type: 'dropdown',
          label: 'What do employees have to provide when they waive coverage?',
          name: 'medical_waive_requirement',
          options: ['Select', 'Document', 'Reason', 'Document and Reason', 'Nothing'],
          value: ''
        },
        {
          id: 'q-5-1-2',
          type: 'text',
          label: 'Which all plan types require waive coverage question? Example Medical, Dental, Vision etc',
          name: 'medical_waive_plan_types',
          placeholder: 'Enter plan types',
          value: ''
        },
        // ===== NEW HIRE ENROLLMENT WINDOW - INDIVIDUAL FIELDS =====
        {
          id: 'q-5-4-1',
          type: 'dropdown',
          label: 'New Hire Enrollment window ends on?',
          name: 'medical_nh_window_option',
          options: ['Select an Option', 'X days following the Date of Hire', 'First of the month following X days from Date of Hire', 'First of the month following or coinciding with X days from Date of Hire'],
          value: ''
        },
        {
          id: 'q-5-4-2',
          type: 'number',
          label: 'Days',
          name: 'medical_nh_window_days',
          placeholder: 'Enter Number of days',
          value: ''
        },
        // ===== NEW HIRE WAITING PERIOD - INDIVIDUAL FIELDS =====
        {
          id: 'q-5-5-1',
          type: 'dropdown',
          label: 'New Hire waiting period?',
          name: 'medical_nh_waiting_option',
          options: ['Select an Option', 'Date of Hire', 'First of the Month Following X Days from Date of Hire', 'X Days Following Date of Hire'],
          value: ''
        },
        {
          id: 'q-5-5-2',
          type: 'number',
          label: 'Days',
          name: 'medical_nh_waiting_days',
          placeholder: 'Enter number of Days',
          value: ''
        },
        // ===== ELIGIBILITY CHANGES - INDIVIDUAL FIELDS =====
        {
          id: 'q-5-6-1',
          type: 'dropdown',
          label: 'For eligibility changes, when do benefits start? Example: Part-Time to Full-Time',
          name: 'medical_elig_start_option',
          options: ['Select an Option', 'Date of Eligibility', 'X days following the Date of Eligibility', 'First of the Month Following X Days from Date of Eligibility', 'First of the Month Following or Coinciding with X Days from Date of Eligibility'],
          value: ''
        },
        {
          id: 'q-5-6-2',
          type: 'number',
          label: 'Days',
          name: 'medical_elig_start_days',
          placeholder: 'Enter number of Days',
          value: ''
        },
        {
          id: 'q-5-7',
          type: 'dropdown',
          label: 'For terminated employees, when do benefits terminate?',
          name: 'medical_term_benefits_end',
          options: ['Select', 'Date of Termination', 'Last day of month following Date of Termination', 'End of the Pay Cycle'],
          value: ''
        },
        {
          id: 'q-5-7-1',
          type: 'text',
          label: 'Does the above Termination rule applies to all plan types? If different specify the plan type with Termination rule?',
          name: 'medical_term_rule_plan_types',
          placeholder: 'Enter plan type with termination rule',
          value: ''
        },
        {
          id: 'q-5-8',
          type: 'dropdown',
          label: 'For eligibility changes, when do benefits terminate? Example Full-Time to Part-Time',
          name: 'medical_elig_change_benefits_end',
          options: ['Select an Option', 'Date of Termination', 'Last day of Month Following Date of Termination', 'End of the Pay Cycle'],
          value: ''
        },
        {
          id: 'q-5-9',
          type: 'checkbox',
          label: 'Select Eligible Dependents?',
          name: 'medical_eligible_dependents',
          options: [
            'All',
            'Spouse (Same and Opposite Gender)',
            'Domestic Partner (Same Gender)',
            'Domestic Partner (Opposite Gender)',
            'Dependent Children of Employee/Spouse',
            'Dependent Children of Domestic Partner',
            'No Dependents'
          ],
          value: []
        },
        {
          id: 'q-5-10',
          type: 'checkboxgroup',
          label: 'Define what proof of eligibility is required and for what events?',
          name: 'medical_proof_eligibility',
          groups: [
            {
              label: 'Proof of Eligibility Required',
              name: 'medical_proof_eligibility',
              options: ['All', 'Marriage Certificate', 'Affidavit of Domestic Partner', 'Birth Certificate', 'None']
            },
            {
              label: 'When?',
              name: 'medical_proof_eligibility_when',
              options: ['All Events', 'New Hire', 'Adding at OE', 'Adding at Qualifying Event', 'Never']
            }
          ],
          value: {}
        },
        {
          id: 'q-5-11',
          type: 'dropdown',
          label: 'When does the coverage terminate when child becomes overaged?',
          name: 'medical_overage_child_term',
          options: ['Select', 'Birthday', 'Month Following the Birthday', 'First of the Year Following the Birthday'],
          value: ''
        }
      ]
    },
    // ===== SECTION 6: Dental =====
    {
      id: 'section-6',
      title: 'Dental',
      questions: [
        {
          id: 'q-6-1',
          type: 'text',
          label: 'Group Number?',
          name: 'dental_group_number',
          placeholder: 'Enter group number',
          value: ''
        },
        {
          id: 'q-6-1-1',
          type: 'checkbox',
          label: 'Payroll Deduction Tax?',
          name: 'dental_payroll_deduction_tax',
          options: ['Pre-Tax', 'Post-Tax'],
          value: []
        },
        {
          id: 'q-6-2',
          type: 'dropdown',
          label: 'What do employees have to provide when they waive coverage?',
          name: 'dental_waive_requirement',
          options: ['Select', 'Document', 'Reason', 'Document and Reason', 'Nothing'],
          value: ''
        }
      ]
    },
    // ===== SECTION 7: Vision =====
    {
      id: 'section-7',
      title: 'Vision',
      questions: [
        {
          id: 'q-7-1',
          type: 'text',
          label: 'Group Number?',
          name: 'vision_group_number',
          placeholder: 'Enter group number',
          value: ''
        },
        {
          id: 'q-7-1-1',
          type: 'checkbox',
          label: 'Payroll Deduction Tax?',
          name: 'vision_payroll_deduction_tax',
          options: ['Pre-Tax', 'Post-Tax'],
          value: []
        },
        {
          id: 'q-7-2',
          type: 'dropdown',
          label: 'What do employees have to provide when they waive coverage?',
          name: 'vision_waive_requirement',
          options: ['Select', 'Document', 'Reason', 'Document and Reason', 'Nothing'],
          value: ''
        }
      ]
    },
    // ===== SECTION 8: Basic Life =====
    {
      id: 'section-8',
      title: 'Basic Life',
      questions: [
        {
          id: 'q-8-1',
          type: 'text',
          label: 'Group Number?',
          name: 'basiclife_group_number',
          placeholder: 'Enter group number',
          value: ''
        },
        {
          id: 'q-8-1-1',
          type: 'checkbox',
          label: 'Payroll Deduction Tax?',
          name: 'basiclife_payroll_deduction_tax',
          options: ['Pre-Tax', 'Post-Tax'],
          value: []
        },
        {
          id: 'q-8-2',
          type: 'text',
          label: 'Benefit Amount for Employee?',
          name: 'benefit_amount',
          placeholder: 'Enter amount',
          value: ''
        },
        {
          id: 'q-8-3',
          type: 'dropdown',
          label: 'Guarantee Issue coverage?',
          name: 'guarantee_issue_coverage',
          options: ['Select', 'Not applicable, entire amount is Guaranteed', 'Flat amount $'],
          value: ''
        },
        {
          id: 'q-8-4',
          type: 'dropdown',
          label: 'Coverage Rounding?',
          name: 'coverage_rounding',
          options: ['Select', 'No Rounding', 'Next Highest $25,000', 'Nearest $25,000', 'Round down to $25,000', 'Next Highest $10,000', 'Nearest $10,000', 'Round down to $10,000', 'Next Highest $5,000', 'Nearest $5,000', 'Round down to $5,000', 'Next Highest $1,000', 'Nearest $1,000', 'Round down to $1,000', 'Next Highest $500', 'Nearest $500', 'Round down to $500', 'Next Highest $100', 'Nearest $100', 'Round down to $100', 'Next Highest $50', 'Nearest $50', 'Round down to $50', 'Next Highest $10', 'Nearest $10', 'Round down to $10'],
          value: ''
        },
        {
          id: 'q-8-5',
          type: 'dropdown',
          label: 'Employees who do not complete enrollment process will be?',
          name: 'employee_enrollment',
          options: ['Select', 'Auto Enroll on Hire Date', 'Auto Enroll on the completion of New Hire Window', 'Not Applicable'],
          value: ''
        }
      ]
    },
    // ===== SECTION 9: Voluntary Life =====
    {
      id: 'section-9',
      title: 'Voluntary Life',
      questions: [
        {
          id: 'q-9-1',
          type: 'text',
          label: 'Group Number?',
          name: 'voluntary_life_group_number',
          placeholder: 'Enter group number',
          value: ''
        },
        {
          id: 'q-9-1-1',
          type: 'checkbox',
          label: 'Payroll Deduction Tax?',
          name: 'voluntary_life_payroll_deduction_tax',
          options: ['Pre-Tax', 'Post-Tax'],
          value: []
        },
        {
          id: 'q-9-2',
          type: 'dropdown',
          label: 'Is enrollment in another plan required to participate in this plan?',
          name: 'voluntary_life_enroll',
          options: ['Select', 'Yes', 'No'],
          value: ''
        },
        {
          id: 'q-9-3',
          type: 'dropdown',
          label: 'What do employees have to provide when they waive coverage?',
          name: 'voluntary_life_waive_requirement',
          options: ['Select', 'Document', 'Reason', 'Document and Reason', 'Nothing'],
          value: ''
        },
        {
          id: 'q-9-4',
          type: 'dropdown',
          label: 'Are mid-year enrollment changes allowed without Qualifying Life Events?',
          name: 'voluntary_life_midyear_changes',
          options: ['Select', 'Yes', 'No'],
          value: ''
        },
        {
          id: 'q-9-5',
          type: 'dropdown',
          label: 'For the coverage with salary increments, how do the benefit increase due to salary increase be handled?',
          name: 'coverage_salary_increments',
          options: ['Select', 'Always Pend Additional Benefit', 'Never', 'Pend Additional Benefit Over GI', 'Pend the Benefit Increase over ___% or over GI'],
          value: ''
        },
        {
          id: 'q-9-6',
          type: 'dropdown',
          label: 'For the coverage change with salary increments, when does the coverage change?',
          name: 'coverage_change_timing',
          options: ['Select', 'Coverage does not Change', 'Date of salary increase', 'Plan Anniversary', 'Increase from first of the following month of the salary change date'],
          value: ''
        },
        {
          id: 'q-9-7',
          type: 'dropdown',
          label: 'Coverage Rounding?',
          name: 'vol_coverage_rounding',
          options: ['Select', 'No Rounding', 'Next Highest $25,000', 'Nearest $25,000', 'Round down to $25,000', 'Next Highest $10,000', 'Nearest $10,000', 'Round down to $10,000', 'Next Highest $5,000', 'Nearest $5,000', 'Round down to $5,000', 'Next Highest $1,000', 'Nearest $1,000', 'Round down to $1,000', 'Next Highest $500', 'Nearest $500', 'Round down to $500', 'Next Highest $100', 'Nearest $100', 'Round down to $100', 'Next Highest $50', 'Nearest $50', 'Round down to $50', 'Next Highest $10', 'Nearest $10', 'Round down to $10'],
          value: ''
        },
        // ===== CHANGED: Employee Age Reduction schedule =====
        // Was a plain 'dropdown' (Select/Yes/No). Now a 'yesNoTable' so that
        // selecting "Yes" reveals an editable, initially-EMPTY table (S.No /
        // Benefit reduces % / At Age) with Add New / Edit / Delete, matching
        // the attached screenshot. No hardcoded 35/65/50/70 sample values -
        // rows start blank and are entered per-client via "Add New".
        {
          id: 'q-9-8',
          type: 'yesNoTable',
          label: 'Employee Age Reduction schedule?',
          name: 'employee_age_reduction',
          value: '',
          rows: []
        },
        {
          id: 'q-9-9',
          type: 'dropdown',
          label: 'When does the benefit reduce due to Age Reduction?',
          name: 'employee_age_reduction_timing',
          options: ['Select', 'Plan Anniversary', 'Birthday', 'Month following Birthday'],
          value: ''
        },
        {
          id: 'q-9-9-1',
          type: 'dropdown',
          label: 'Employee age reduction rounding?',
          name: 'employee_age_reduction_rounding',
          options: ['Select', 'No Rounding', 'Next Highest $25,000', 'Nearest $25,000', 'Round down to $25,000', 'Next Highest $10,000', 'Nearest $10,000', 'Round down to $10,000', 'Next Highest $5,000', 'Nearest $5,000', 'Round down to $5,000', 'Next Highest $1,000', 'Nearest $1,000', 'Round down to $1,000', 'Next Highest $500', 'Nearest $500', 'Round down to $500', 'Next Highest $100', 'Nearest $100', 'Round down to $100', 'Next Highest $50', 'Nearest $50', 'Round down to $50', 'Next Highest $10', 'Nearest $10', 'Round down to $10'],
          value: ''
        },
        // ===== EMPLOYEE GUARANTEED ISSUE AMOUNT - CHECKBOX WITH BLANKS =====
        {
          id: 'q-9-9-2',
          type: 'checkboxWithBlanks',
          label: 'Employee Guaranteed Issue Amount?',
          name: 'employee_gi_amount',
          value: [],
          blankValues: {},
          options: [
            {
              id: 'option1',
              segments: [
                { type: 'text', text: 'Flat amount of $' },
                { type: 'blank', id: 'flat_amt', placeholder: '$' }
              ]
            },
            {
              id: 'option2',
              segments: [
                { type: 'blank', id: 'salary_multiple', placeholder: '#' },
                { type: 'text', text: 'times salary upto a max of $' },
                { type: 'blank', id: 'max_amt', placeholder: '$' },
                { type: 'text', text: ', rounded to' }
              ]
            },
            {
              id: 'option3',
              segments: [
                { type: 'text', text: '$' },
                { type: 'blank', id: 'newhire_amt', placeholder: '$' },
                { type: 'text', text: 'for new hire and $' },
                { type: 'blank', id: 'thereafter_amt', placeholder: '$' },
                { type: 'text', text: 'there after' }
              ]
            },
            {
              id: 'option4',
              segments: [
                { type: 'text', text: '$' },
                { type: 'blank', id: 'age_under_amt', placeholder: '$' },
                { type: 'text', text: 'if employee\'s age is' },
                { type: 'blank', id: 'age_threshold', placeholder: '#' },
                { type: 'text', text: 'years or under, otherwise $' },
                { type: 'blank', id: 'age_over_amt', placeholder: '$' }
              ]
            }
          ]
        },
        {
          id: 'q-9-10',
          type: 'dropdown',
          label: 'For coverage above Guarantee Issue, employees need to fill?',
          name: 'coverage_above_gi',
          options: ['Select', 'Evidence of Insurability Online Form', 'Evidence of Insurability Form', 'Evidence of Insurability Underwriting Questions', 'Nothing'],
          value: ''
        },
        {
          id: 'q-9-11',
          type: 'text',
          label: 'For coverage above Guarantee Issue - Enter details?',
          name: 'coverage_above_gi_details',
          placeholder: 'Enter details',
          value: ''
        },
        {
          id: 'q-9-12',
          type: 'dropdown',
          label: 'Base age for rate calculation for New Hires?',
          name: 'base_age_newhires',
          options: ['Select', 'Plan Effective Date', 'Age as of __(future or past date allowed)'],
          value: ''
        },
        {
          id: 'q-9-13',
          type: 'dropdown',
          label: 'Effective Date of Age-related premium changes?',
          name: 'effective_date_age_premium',
          options: ['Select', 'Plan Anniversary', 'Birthday', 'Month Following the Birthday', 'Frozen rate', 'Plan Effective Date', 'Age as of __(future or past date allowed)'],
          value: ''
        },
        // ===== EMPLOYEE GUARANTEED ISSUE RULE DURING OE - CHECKBOX WITH BLANKS =====
        // Same wording/blanks as the "Voluntary Life - Additional GI Options
        // during OE - Employee?" question below (q-9-14), but rendered as
        // checkboxWithBlanks (multi-select) instead of radioWithBlanks
        // (single-select), per request.
        {
          id: 'q-9-13-1',
          type: 'checkboxWithBlanks',
          label: 'Employee Guaranteed Issue rule during OE?',
          name: 'employee_gi_rule_oe',
          value: [],
          blankValues: {},
          options: [
            {
              id: 'option1',
              segments: [
                { type: 'text', text: 'Current enrolled employee can elect up to' },
                { type: 'blank', id: 'enrolled', placeholder: '#' },
                { type: 'text', text: 'increments within GI without EOI and not enrolled employee can elect up to' },
                { type: 'blank', id: 'notEnrolled', placeholder: '#' },
                { type: 'text', text: 'increments within GI without EOI' }
              ]
            },
            { id: 'option2', segments: [{ type: 'text', text: 'Any increase in the current election requires EOI' }] },
            { id: 'option3', segments: [{ type: 'text', text: 'Elections above GI requires EOI' }] }
          ]
        },
        // ===== VOLUNTARY LIFE - ADDITIONAL GI OPTIONS DURING OE =====
        // type 'radioWithBlanks': a single-select list of options (radio buttons,
        // since only one of the three can apply at a time) where Option 1 has
        // two numeric blanks built directly into its sentence. Replaces the
        // earlier dropdown + separate number fields, since a native <select>
        // option can't contain an input box - the blanks can never live
        // "inside" a dropdown option.
        {
          id: 'q-9-14',
          type: 'radioWithBlanks',
          label: 'Voluntary Life - Additional GI Options during OE - Employee?',
          name: 'vol_life_gi_oe_employee',
          value: '',
          blankValues: { enrolled: '', notEnrolled: '' },
          options: [
            {
              id: 'option1',
              segments: [
                { type: 'text', text: 'Option 1: Current enrolled employee can elect up to' },
                { type: 'blank', id: 'enrolled', placeholder: '#' },
                { type: 'text', text: 'increments within GI without EOI and not enrolled employee can elect up to' },
                { type: 'blank', id: 'notEnrolled', placeholder: '#' },
                { type: 'text', text: 'increments within GI without EOI' }
              ]
            },
            { id: 'option2', segments: [{ type: 'text', text: 'Option 2: Any increase in the current election requires EOI' }] },
            { id: 'option3', segments: [{ type: 'text', text: 'Option 3: Elections above GI go through EOI' }] }
          ]
        },
        {
          id: 'q-9-15',
          type: 'radioWithBlanks',
          label: 'Voluntary Life - Additional GI Options during OE - Spouse?',
          name: 'vol_life_gi_oe_spouse',
          value: '',
          blankValues: { enrolled: '', notEnrolled: '' },
          options: [
            {
              id: 'option1',
              segments: [
                { type: 'text', text: 'Option 1: Current enrolled spouse can elect up to' },
                { type: 'blank', id: 'enrolled', placeholder: '#' },
                { type: 'text', text: 'increments within GI without EOI and not enrolled can elect up to' },
                { type: 'blank', id: 'notEnrolled', placeholder: '#' },
                { type: 'text', text: 'increments within GI without EOI' }
              ]
            },
            { id: 'option2', segments: [{ type: 'text', text: 'Option 2: Any increase in the current election requires EOI' }] },
            { id: 'option3', segments: [{ type: 'text', text: 'Option 3: Elections above GI go through EOI' }] }
          ]
        },
        {
          id: 'q-9-16',
          type: 'radioWithBlanks',
          label: 'Voluntary Life - Additional GI Options during OE - Child?',
          name: 'vol_life_gi_oe_child',
          value: '',
          blankValues: { enrolled: '', notEnrolled: '' },
          options: [
            {
              id: 'option1',
              segments: [
                { type: 'text', text: 'Option 1: Current enrolled child can elect up to' },
                { type: 'blank', id: 'enrolled', placeholder: '#' },
                { type: 'text', text: 'increments within GI without EOI and not enrolled can elect up to' },
                { type: 'blank', id: 'notEnrolled', placeholder: '#' },
                { type: 'text', text: 'increments within GI without EOI' }
              ]
            },
            { id: 'option2', segments: [{ type: 'text', text: 'Option 2: Any increase in the current election requires EOI' }] },
            { id: 'option3', segments: [{ type: 'text', text: 'Option 3: Elections above GI go through EOI' }] }
          ]
        },
        {
          id: 'q-9-17',
          type: 'dropdown',
          label: 'Spouse/DP Premium based on?',
          name: 'spouse_dp_premium',
          options: ['Select', 'Employee\'s Age', 'Spouse\'s Age'],
          value: ''
        },
        {
          id: 'q-9-18',
          type: 'dropdown',
          label: 'Spouse/DP Coverage Rounding Rule?',
          name: 'spouse_dp_rounding',
          options: ['Select', 'No Rounding', 'Next Highest $25,000', 'Nearest $25,000', 'Round down to $25,000', 'Next Highest $10,000', 'Nearest $10,000', 'Round down to $10,000', 'Next Highest $5,000', 'Nearest $5,000', 'Round down to $5,000', 'Next Highest $1,000', 'Nearest $1,000', 'Round down to $1,000', 'Next Highest $500', 'Nearest $500', 'Round down to $500', 'Next Highest $100', 'Nearest $100', 'Round down to $100', 'Next Highest $50', 'Nearest $50', 'Round down to $50', 'Next Highest $10', 'Nearest $10', 'Round down to $10'],
          value: ''
        },
        {
          id: 'q-9-19',
          type: 'dropdown',
          label: 'Spouse Age Reduction schedule?',
          name: 'spouse_age_reduction',
          options: ['Select', 'Yes', 'No'],
          value: ''
        },
        {
          id: 'q-9-20',
          type: 'dropdown',
          label: 'When does the coverage terminate when child becomes overaged?',
          name: 'voluntary_child_overage',
          options: ['Select', 'Birthday', 'Month Following the Birthday', 'First of the Year Following the Birthday'],
          value: ''
        }
      ]
    },
    // ===== SECTION 10: Short - Term Disability =====
    {
      id: 'section-10',
      title: 'Short - Term Disability',
      questions: [
        {
          id: 'q-10-1',
          type: 'text',
          label: 'Group Number?',
          name: 'short_term_disability_group_number',
          placeholder: 'Enter group number',
          value: ''
        },
        {
          id: 'q-10-1-1',
          type: 'checkbox',
          label: 'Payroll Deduction Tax?',
          name: 'std_payroll_deduction_tax',
          options: ['Pre-Tax', 'Post-Tax'],
          value: []
        },
        // ===== BENEFIT AMOUNT - CHECKBOX WITH BLANKS =====
        // type 'checkboxWithBlanks': like radioWithBlanks, but options are
        // checkboxes (multiple can be selected at once) instead of a single
        // radio choice, since more than one of these amount definitions can
        // apply. Each option's sentence has its own inline numeric blank(s)
        // built directly into the segments, same pattern as radioWithBlanks.
        {
          id: 'q-10-1-2',
          type: 'checkboxWithBlanks',
          label: 'Benefit Amount?',
          name: 'std_benefit_amount',
          value: [],
          blankValues: {},
          options: [
            {
              id: 'option1',
              segments: [
                { type: 'blank', id: 'flat_amt', placeholder: '$' }
              ]
            },
            {
              id: 'option2',
              segments: [
                { type: 'blank', id: 'pct_salary', placeholder: '%' },
                { type: 'text', text: '% of weekly Salary to a Maximum of $' },
                { type: 'blank', id: 'max_amt', placeholder: '$' }
              ]
            },
            {
              id: 'option3',
              segments: [
                { type: 'text', text: 'Other' },
                { type: 'blank', id: 'other_amt', placeholder: 'Specify' }
              ]
            }
          ]
        },
        {
          id: 'q-10-2',
          type: 'dropdown',
          label: 'Coverage Rounding?',
          name: 'std_coverage_rounding',
          options: ['Select', 'No Rounding', 'Next Highest $25,000', 'Nearest $25,000', 'Round down to $25,000', 'Next Highest $10,000', 'Nearest $10,000', 'Round down to $10,000', 'Next Highest $5,000', 'Nearest $5,000', 'Round down to $5,000', 'Next Highest $1,000', 'Nearest $1,000', 'Round down to $1,000', 'Next Highest $500', 'Nearest $500', 'Round down to $500', 'Next Highest $100', 'Nearest $100', 'Round down to $100', 'Next Highest $50', 'Nearest $50', 'Round down to $50', 'Next Highest $10', 'Nearest $10', 'Round down to $10'],
          value: ''
        },
        // ===== PREMIUMS - CHECKBOX WITH BLANKS =====
        // Option 1 also carries a 'dropdown' segment (Select/Salary/Benefit)
        // built inline into the sentence, in addition to numeric blanks.
        {
          id: 'q-10-2-2',
          type: 'checkboxWithBlanks',
          label: 'Premiums?',
          name: 'std_premiums',
          value: [],
          blankValues: {},
          options: [
            {
              id: 'option1',
              segments: [
                { type: 'blank', id: 'rate_amt', placeholder: '$' },
                { type: 'text', text: 'per $' },
                { type: 'blank', id: 'per_amt', placeholder: '$' },
                { type: 'text', text: 'of' },
                { type: 'blank', id: 'pct_amt', placeholder: '%' },
                { type: 'text', text: '% of Weekly' },
                { type: 'dropdown', id: 'weekly_basis', options: ['Select', 'Salary', 'Benefit'] }
              ]
            },
            {
              id: 'option2',
              segments: [
                { type: 'text', text: 'Age-Banded rates based on' },
                { type: 'blank', id: 'agebanded_pct', placeholder: '%' },
                { type: 'text', text: '% of Weekly' }
              ]
            },
            {
              id: 'option3',
              segments: [
                { type: 'text', text: 'Flat rate of $' },
                { type: 'blank', id: 'male_rate', placeholder: '$' },
                { type: 'text', text: 'for males and $' },
                { type: 'blank', id: 'female_rate', placeholder: '$' },
                { type: 'text', text: 'for females' }
              ]
            }
          ]
        },
        // ===== PREMIUMS SHARING AND ROUNDING RULES - CHECKBOX WITH BLANKS =====
        {
          id: 'q-10-2-3',
          type: 'checkboxWithBlanks',
          label: 'Premiums Sharing and Rounding Rules?',
          name: 'std_premium_sharing',
          value: [],
          blankValues: {},
          options: [
            {
              id: 'option1',
              segments: [
                { type: 'text', text: 'Non-contributory (employer pays 100%)' }
              ]
            },
            {
              id: 'option2',
              segments: [
                { type: 'text', text: 'Employee pays' },
                { type: 'blank', id: 'emp_pct', placeholder: '%' },
                { type: 'text', text: '% of premium' }
              ]
            },
            {
              id: 'option3',
              segments: [
                { type: 'text', text: 'Employee pays $' },
                { type: 'blank', id: 'emp_amt', placeholder: '$' },
                { type: 'text', text: 'of premium' }
              ]
            },
            {
              id: 'option4',
              segments: [
                { type: 'text', text: 'Employer pays upto' },
                { type: 'blank', id: 'er_pct', placeholder: '%' },
                { type: 'text', text: '% of the benefit upto a maximum $' },
                { type: 'blank', id: 'er_max', placeholder: '$' }
              ]
            },
            {
              id: 'option5',
              segments: [
                { type: 'text', text: 'Employer pays $' },
                { type: 'blank', id: 'er_amt', placeholder: '$' },
                { type: 'text', text: 'of premium' }
              ]
            }
          ]
        },
        {
          id: 'q-10-2-1',
          type: 'dropdown',
          label: 'Monthly Payroll/Covered Benefit Rounding Rule?',
          name: 'std_monthly_payroll_rounding',
          options: ['Please Select Option', 'No Rounding', 'Next highest $10', 'Nearest $10', 'Round down to $10', 'Round up to next Whole dollar', 'Round down to lower whole dollar', 'Conventional rounding to the whole dollar'],
          value: ''
        }
      ]
    },
    // ===== SECTION 11: Long - Term Disability =====
    {
      id: 'section-11',
      title: 'Long - Term Disability',
      questions: [
        {
          id: 'q-11-1',
          type: 'text',
          label: 'Group Number?',
          name: 'long_term_disability_group_number',
          placeholder: 'Enter group number',
          value: ''
        },
        {
          id: 'q-11-1-1',
          type: 'checkbox',
          label: 'Payroll Deduction Tax?',
          name: 'ltd_payroll_deduction_tax',
          options: ['Pre-Tax', 'Post-Tax'],
          value: []
        },
        {
          id: 'q-11-2',
          type: 'dropdown',
          label: 'Coverage Rounding?',
          name: 'ltd_coverage_rounding',
          options: ['Select', 'No Rounding', 'Next Highest $25,000', 'Nearest $25,000', 'Round down to $25,000', 'Next Highest $10,000', 'Nearest $10,000', 'Round down to $10,000', 'Next Highest $5,000', 'Nearest $5,000', 'Round down to $5,000', 'Next Highest $1,000', 'Nearest $1,000', 'Round down to $1,000', 'Next Highest $500', 'Nearest $500', 'Round down to $500', 'Next Highest $100', 'Nearest $100', 'Round down to $100', 'Next Highest $50', 'Nearest $50', 'Round down to $50', 'Next Highest $10', 'Nearest $10', 'Round down to $10'],
          value: ''
        },
        {
          id: 'q-11-2-1',
          type: 'dropdown',
          label: 'Monthly Payroll/Covered Benefit Rounding Rule?',
          name: 'ltd_monthly_payroll_rounding',
          options: ['Please Select Option', 'No Rounding', 'Next highest $10', 'Nearest $10', 'Round down to $10', 'Round up to next Whole dollar', 'Round down to lower whole dollar', 'Conventional rounding to the whole dollar'],
          value: ''
        }
      ]
    }
  ]
};